export const elementIcons = [
	"email",
	"zhuanchezhuanyongbeifen",
	"banquan",
	"qidong",
	"xitongrizhi",
	"shengyin-kai",
	"shengyin-guan",
	"a-bell",
	"a-avatar",
	"a-chat-line-square",
	"a-discount",
	"a-grid",
	"a-histogram",
	"a-link",
	"a-menu",
	"a-message",
	"a-message-box",
	"a-info-filled",
	"a-operation",
	"a-user",
	"a-user-filled",
	"a-switch",
	"a-d-arrow-left",
	"a-d-arrow-right",
	"a-sort",
	"a-data-analysis",
	"a-data-line",
	"a-list",
	"a-management",
	"a-trend-charts",
	"a-picture-folled",
	"a-picture",
	"a-platform",
	"a-guide",
	"a-location",
	"a-map-location",
	"a-school",
	"a-office-building",
	"a-hot-water",
	"a-briefcase",
	"a-brush-filled",
	"a-brush",
	"a-calendar",
	"a-coin",
	"a-credit-card",
	"a-finance-filled",
	"a-flag",
	"a-goods-filled",
	"a-key",
	"a-phone",
	"a-present",
	"a-printer",
	"a-scissors",
	"a-shopping-cart-full",
	"a-shopping-cart-trolley",
	"a-stamp",
	"icon-Call",
	"a-icon-VideoCall",
	"a-icon-MuteOn",
	"a-icon-MuteOff",
	"icon-fenxiang",
	"a-icon-BackCamera",
	"icon-friend-in",
	"icon-friend",
	"icon-xiaoxi",
	"phone",
	"phone1",
	"icon-sdp-bizhong2-16",
	"con-sdp-huobijianxie-16",
	"con-sdp-huobijianxie2-16",
	"jicheng",
	"zhuanshengchan",
	"icon-time",
	"icon-tupian",
	"number",
	"bank-fill",
	"shop",
	"apartment",
	"a-adduser",
	"api",
	"database-fill",
	"a-deploymentunit",
	"detail",
	"file-image-fill",
	"file-ppt-fill",
	"file-ppt",
	"file-unknown-fill",
	"file-text-fill",
	"file-word-fill",
	"folder-open-fill",
	"file-GIF",
	"file-word",
	"gold",
	"group",
	"menu",
	"read",
	"reconciliation",
	"scan",
	"solution",
	"a-team1",
	"xinzengziji",
	"jiankong",
	"moxing",
	"shebei",
	"xunjian",
	"jiashicang",
	"tongyongpeizhi",
	"zidianguanli",
	"jinrongmaichebeifen",
	"home",
	"icon-test",
	"icon-test1",
	"icon-test2",
	"icon-test3",
	"icon-test4",
	"xinzeng",
	"shanchu",
	"xiangmu",
	"gengduo",
	"bianji",
	"riqi",
	"fabu",
	"qiyong",
	"daoru",
	"chakan",
	"qiyong1",
	"quanping",
	"tuichuquanping",
	"arrowleft",
	"arrowright",
	"down",
	"calendar",
	"ellipsis",
	"a-doubleright",
	"doubleleft",
	"folder",
	"arrowup",
	"edit",
	"poweroff",
	"reload",
	"search",
	"a-eyeclose-fill",
	"fullscreen",
	"tuichuquanping1",
	"unlock",
	"tag",
	"lock",
	"caidan",
	"user",
	"key",
	"upload",
	"setting-fill",
	"false",
	"caidan1",
	"add",
	"a-areachart",
	"expend",
	"exclaimination",
	"folder-add",
	"infomation",
	"man",
	"liebiao",
	"xiangmu1",
	"dengji",
	"dianpu",
	"fushixiemao",
	"erweima",
	"fenxiang",
	"fuzhi",
	"jiedan",
	"gerenxinxi",
	"qunti",
	"gengduo1",
	"kefu",
	"jianshao",
	"shouju",
	"qianbao",
	"shangbiao",
	"gouwu",
	"shanchudingdan",
	"paidan",
	"jinrong",
	"saoma",
	"shoucang",
	"renwu",
	"sousuo1",
	"fanhui",
	"guan",
	"shijian",
	"fenxiang1",
	"guanbi",
	"shaixuan",
	"liulan",
	"tianxie",
	"gouwuche",
	"jianpan",
	"qingchu",
	"youjiantou",
	"xiajiantou",
	"shezhi",
	"huguan",
	"kefu1",
	"erweima1",
	"zhubozhongxin"
].map((s) => "al-icon-" + s);
